import '../css/TapMarker.css';
import { EXTERNAL_BROWSER_GUIDE_TAP_LABEL } from '../constants/bookingConst';

/**
 * A pulsing marker with a small "Tap" tag, drawn over a picture to point at
 * what to press. Two shapes:
 *  - 'ring' (default): a circle on one spot (a button such as •••). The
 *    caller positions it (absolutely) with `className`, and the ring centres
 *    itself on that spot.
 *  - 'outline': a rounded outline around the whole of its parent (a menu
 *    row), with the tag inside on the right. The parent must be positioned.
 *
 * Decorative only: the step text beside the picture says what to tap.
 *
 * @param {object} props
 * @param {string} [props.className] - positions a ring marker on the picture
 * @param {'ring'|'outline'} [props.shape='ring'] - spot or whole-element marker
 * @param {'below'|'left'} [props.labelSide='below'] - ring only: where the tag sits
 * @returns {JSX.Element}
 */
function TapMarker({ className = '', shape = 'ring', labelSide = 'below' }) {
  const shapeClass = shape === 'outline' ? 'tap-marker--outline' : `tap-marker--label-${labelSide}`;
  return (
    <span className={`tap-marker ${shapeClass} ${className}`.trim()} aria-hidden="true">
      <span className="tap-marker-ring" />
      <span className="tap-marker-label">{EXTERNAL_BROWSER_GUIDE_TAP_LABEL}</span>
    </span>
  );
}

export default TapMarker;
